import { Inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { dataSourceFilterActions } from "./data-source-filter.actions";
import { AdminApiService } from "app/api/admin.api.service";
import { catchError, map, of, share, switchMap, tap } from "rxjs";

@Injectable()
export class DataSourceFilterEffects {
    loadTree$ = createEffect(() =>
        this.actions$.pipe(
            ofType(dataSourceFilterActions.loadTree),
            switchMap(() => {
                return this.api.getDataSources(false).pipe(
                    map((tree) =>
                        dataSourceFilterActions.loadTreeSuccess({ tree }),
                    ),
                    catchError((error) =>
                        of(dataSourceFilterActions.loadTreeFailure({ error })),
                    ),
                );
            }),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private api: AdminApiService,
    ) {}
}
